<template>

<div :class="[ 'single', { 'is-hidden': singleIsHidden }]">

    <single-header :project="project">
        <p>María is a visual and fine artist from Columbia now based in Berlin.
        She works in painting, installation and illustration, as well as in art
        direction and production design for media and film projects.</p>
    </single-header>

    <!-- SECTION -->

    <single-section>

        <video src="assets/projects/maria-jose-moreno/slider.mp4" autoplay loop></video>

    </single-section>

    <!-- SECTION -->

    <single-section header="Dynamic WordPress">

        <p>The slider on all pages are being loaded in dynamically to avoid a full page refresh.</p>

        <video src="assets/projects/maria-jose-moreno/transition.mp4" autoplay loop></video>

    </single-section>

</div>

</template>

<script>
import { singleHandler } from '@/modules/mixins'

export default {
    data() {
        return {
            project: {
                title: 'María José Moreno',
                subtitle:'Visual Artist in Berlin',
                background: 'url(assets/projects/maria-jose-moreno/project-header.jpg)',
                color: '#3d3d3d',
                logoSuffix: 'png',
                role: 'Portfolio',
                features: 'AJAX-driven WordPress',
                url: 'http://mariajmoreno.com'
            }
        }
    },
    mixins: [singleHandler]
}
</script>



// WEBPACK FOOTER //
// maria-jose-moreno.vue?4206f9a0